import React from 'react';
import HeaderNavbar from './HeaderNavbar';
import HeaderMain from './HeaderMain';

const PageHeader = () => (
  <>
    <header>
      <HeaderNavbar />
      <HeaderMain />
    </header>
  </>
);

export default PageHeader;
